// all image sizes https://github.com/wkda/image-processing-lambda/blob/master/config/mapping.js

export const REGULAR_SIZES = {
  big: 'b-',
  xbig: 'b-x2-',
  medium: 'm-',
  xmedium: 'sr-x2-',
  small: 's-',

  nano: 'nano-',
  logo: 'logo-',
  original: '',
  s110x83: '110x83-',
  s136x102: '136x102-',
  s144x108: '144x108-',
  s150x113: '150x113-',
  s164x123: '164x123-',
  s169x127: '169x127-',
  s200x150: '200x150',
  s220x165: '220x165-',
  s288x216: '288x216-',
  s300x225: '300x225-',
  s304x228: '304x228-',
  s440x330: '440x330-',
  s640x480: '640x480-',
  s88x66: '88x66-',
  s90x68: '90x68-',
};

export const AUTOHERO_SIZE = {
  nano: 'nano-',
  original: '',
  s1080x810: '1080x810-',
  s118x89: '118x89-',
  s1280x960: '1280x960-',
  s144x108: '144x108-',
  s220x165: '220x165-',
  s320x240: '320x240-',
  s470x353: '470x353-',
  s720x540: '720x540-',
};
